export { OrganizationDetailLayout } from './DetailLayout';
